import { render, staticRenderFns } from "./Marketcard.vue?vue&type=template&id=5078547f&scoped=true"
import script from "./Marketcard.vue?vue&type=script&lang=js"
export * from "./Marketcard.vue?vue&type=script&lang=js"
import style0 from "./Marketcard.vue?vue&type=style&index=0&id=5078547f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078547f",
  null
  
)

export default component.exports